import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Box} from "../../../model/box";

@Component({
  selector: 'aw-add-box-interface-dialog',
  templateUrl: './add-sim-dialog.component.html',
  styleUrls: ['./add-sim-dialog.component.scss']
})
export class AddSimDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Box,
    public dialogRef: MatDialogRef<AddSimDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


